import i18next from 'i18next';

i18next.addResources('es', 'infraestructureSelector', {
  infraestructureTypes: 'Infraestructura',
  energy: 'Energía',
  boundary: 'Fronteras',
  transport: 'Transporte y logística',
  telecommunications: 'Telecomunicaciones'
});
